import { Mousewheel, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { pioneersLoveAi } from '../common/Helper'
import { ArrowLeft, ArrowRight } from '../common/Icons'
import PrimaryHeading from '../custom-ui/PrimaryHeading'

import PioneersCard from './PioneersCard'

const PioneersLove = () => {
  return (
    <div className="px-6 pt-[100px] sm:px-0 sm:pt-[168px]">
      <div className="container mx-auto sm:px-6 xl:max-w-[1200px] xl:px-0">
        <PrimaryHeading class=" leading-none">
          {' '}
          Why pioneers{' '}
          <span className="relative font-semibold after:absolute after:bottom-0 after:left-1/2 after:h-[13px] after:w-full after:-translate-x-1/2 after:bg-underlineBlue after:bg-contain after:bg-no-repeat">
            love
          </span>{' '}
          Day.ai
        </PrimaryHeading>
      </div>
      <div className="icon flex justify-center pt-7 sm:pt-12">
        <span className="custom-swiper-button-prev group cursor-pointer">
          <ArrowLeft />
        </span>
        <span className="custom-swiper-button-next group cursor-pointer">
          <ArrowRight />
        </span>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={12}
        centeredSlides={true}
        mousewheel={{
          forceToAxis: true,
        }}
        direction="horizontal" // Set direction to horizontal
        navigation={{
          prevEl: '.custom-swiper-button-prev',
          nextEl: '.custom-swiper-button-next',
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          1900: {
            slidesPerView: 2.5,
          },
          1100: {
            slidesPerView: 1.8,
          },
          768: {
            slidesPerView: 1.4,
          },
          610: {
            slidesPerView: 1.2,
          },
        }}
        modules={[Pagination, Navigation, Mousewheel]}
        className="mySwiper !pb-10 !pt-7 sm:!pb-16 sm:!pt-12"
      >
        {pioneersLoveAi.map((value, index) => {
          return (
            <SwiperSlide key={index}>
              <PioneersCard
                paragraph={value.paragraph}
                user={value.image}
                username={value.userName}
                jobpost={value.profession}
                company={value.companyIcon}
                companysize={value.iconSize}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default PioneersLove
